import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { useReportsSummary } from '@/api/ads/hooks';
import { PageHeader } from '@/components/PageHeader';
import { Card, CardHeader, CardBody } from '@/components/ui/card';
import { Stat } from '@/components/ui/stat';
import { Spinner } from '@/components/ui/spinner';
import { npr, num, pct, titleCase } from '@/lib/format';

export function ReportsPage() {
  const { data, isLoading } = useReportsSummary();

  const statusData = Object.entries(data?.bookings_by_status ?? {}).map(([status, n]) => ({
    status: titleCase(status),
    count: n,
  }));

  return (
    <>
      <PageHeader title="Reports" description="Delivery and spend for your campaigns." />
      {isLoading ? (
        <Spinner label="Loading report…" />
      ) : (
        <>
          <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
            <Stat label="Campaigns" value={num(data?.campaigns)} />
            <Stat label="Bookings" value={num(data?.bookings)} />
            <Stat label="Impressions" value={num(data?.impressions)} />
            <Stat label="Clicks" value={num(data?.clicks)} hint={`CTR ${pct(data?.ctr_pct ?? 0)}`} />
          </div>
          <div className="mt-3 grid gap-4 lg:grid-cols-2">
            <Stat label="Total spend" value={npr(data?.total_spend)} />
          </div>

          <Card className="mt-5">
            <CardHeader title="Bookings by status" />
            <CardBody>
              {statusData.length === 0 ? (
                <p className="text-sm text-muted-foreground">No bookings yet.</p>
              ) : (
                <div className="h-72">
                  <ResponsiveContainer width="100%" height="100%">
                    <BarChart data={statusData}>
                      <CartesianGrid strokeDasharray="3 3" opacity={0.2} />
                      <XAxis dataKey="status" fontSize={12} />
                      <YAxis allowDecimals={false} fontSize={12} />
                      <Tooltip />
                      <Bar dataKey="count" fill="hsl(349 89% 51%)" radius={[4, 4, 0, 0]} />
                    </BarChart>
                  </ResponsiveContainer>
                </div>
              )}
            </CardBody>
          </Card>
        </>
      )}
    </>
  );
}
